/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useEffect, useState, useCallback, useContext } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';

const Razorpay = ({ Amount, attributes }) => {

    const { setPaymentRes, setPaymentLoading, handleCallApi, setShowToast, setToastMsg } = useContext(MyContext);

    const [userData, setUserData] = useState("");

    const openPayModal = useCallback(() => {

        setPaymentLoading(false);

        const options = {
            key: attributes,
            amount: Amount * 100,
            name: userData?.name || "ZippyGo",
            description: "some description",
            image: "https://cdn.razorpay.com/logos/7K3b6d18wHwKzL_medium.png",
            handler: async (response) => {
                const Userid = secureLocalStorage.getItem("Userid");
                setPaymentLoading(true);
                try {
                    const res = await handleCallApi("Post", "payment/razorpay-verify", {
                        razorpay_payment_id: response.razorpay_payment_id,
                        uid: Userid,
                        amount: Amount
                    });
                    if (res && res.data && res.data.Result) {
                        setPaymentRes("PaymentDone");
                        secureLocalStorage.setItem("transactionid", response.razorpay_payment_id);
                    } else {
                        setPaymentRes("PaymentFaild");
                        setShowToast(true);
                        setToastMsg(res?.data?.message || "Razorpay Verification Failed");
                    }
                } catch (err) {
                    console.error("Razorpay verification failed:", err);
                    setPaymentRes("PaymentFaild");
                    setShowToast(true);
                    setToastMsg("Verification Error");
                }
                setPaymentLoading(false);
            },
            modal: {
                ondismiss: () => {
                    setPaymentRes("PaymentFaild");
                }
            },
            prefill: {
                name: userData && userData?.name,
                contact: userData && userData?.phone,
                email: userData && userData?.email,
            },
            notes: {
                address: "some address",
            },
            theme: {
                color: "#4038ff",
                hide_topbar: false,
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();

    }, [Amount, userData]);

    useEffect(() => {
        const localData = secureLocalStorage.getItem("Logindata");
        if (!Amount || !localData) return;
        const parsedData = JSON.parse(localData);
        setUserData(parsedData);
    }, [Amount]);

    useEffect(() => {
        if (userData && Amount) {
            openPayModal();
        }
    }, [Amount, userData]);

    return null;
};

export default Razorpay;
/* jshint ignore:end */